module.exports = __webpack_public_path__ + "img/warning.cf1700a8.svg";